<template lang="pug">
.gw-cookies
  .gw-cookies__text
    | {{ $t("mygames.cookies.lead") }} 
    a(href="https://documentation.my.games/terms/mygames_cookies" target="_blank") {{ $t("mygames.cookies.link") }} 
    | .
  button.gw-cookies__btn(@click="setCookie") {{ $t("mygames.cookies.button") }} 

</template>
<script>
export default {
  name: "MyGamesCookies",

  methods: {
    setCookie() {
      this.$emit("setCookie");
    },
  },
};
</script>

<style lang="stylus">
.gw-cookies {
  position: relative;
  z-index: 1000;
  padding: 10px 30px;
  min-height: 50px;
  color: #000;
  background: linear-gradient(to right, #ffe99b -1.36%, #ffbe31 147.2%);
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 860px) {
    display: block;
  }
}

.gw-cookies__text {
  margin-right: 20px;
  font-size: 16px;
  line-height: 1.18;
  text-align: left;

  a, a:link, a:visited {
    color: #1598f6;
  }

  a:hover, a:active, a:focus {
    color: #56bfff;
  }

  @media (max-width: 860px) {
    margin: 0 0 10px;
  }
}

.gw-cookies__btn {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  padding: 6px 32px 5px;
  font-size: 16px;
  line-height: 1.18;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  text-decoration: none;
  background-color: #f5f5f7;
  border: 1px solid #cdcdcd;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  transition: all 0.1s;
  user-select: none;

  &:hover, &:active {
    background-color: #e2e3e7;
  }
}
</style>
